import React from "react"
import TopNav from "./header"
import Styles from "../styles/components/PageHero.module.scss"
import Typist from "react-typist"
import CTA from "../components/ctaButton"

const PageHero = props => {
  return (
    <div className={Styles["page-hero-wrapper"]}>
      {props.imgSrc && <img src={props.imgSrc} className={Styles.img}/>}
      <div className={`container-padding ${Styles.container} `}>
        <TopNav />
        <div className={Styles["content-container"]}>
          <div className={Styles["hero-text"]}>
            {props.pageTitle && <span>{props.pageTitle}</span>}
            <h1>
            {props.heading}
              {/* <Typist cursor={{ hideWhenDone: true }}>{props.heading}</Typist> */}
            </h1>
            <p>{props.description}</p>
            {props.buttonTitle && <CTA buttonTitle={props.buttonTitle} buttonUrl={props.buttonUrl}></CTA>}
            {props.secondaryButtonTitle && <CTA buttonTitle={props.secondaryButtonTitle} buttonUrl={props.secondaryButtonUrl} secondaryButton></CTA>}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PageHero
